/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TodoTemplatesListResponse } from '../../models/todo-templates-list-response';

export interface GetTodosTemplates$Params {

/**
 * The type of todo templates we want in the response
 */
  type?: string;
}

export function getTodosTemplates(http: HttpClient, rootUrl: string, params?: GetTodosTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<TodoTemplatesListResponse>> {
  const rb = new RequestBuilder(rootUrl, getTodosTemplates.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TodoTemplatesListResponse>;
    })
  );
}

getTodosTemplates.PATH = '/api/v1/todo_templates';
